module.exports = __webpack_public_path__ + "img/search.5416c034.svg";